import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBlockNavigation } from './NavigationBlockerProvider';

const BlockableLink = ({ to, state, className, style, children, onClick, ...rest }) => {
  const navigate = useNavigate();
  const { getBlocker, showDialog } = useBlockNavigation();

  const handleClick = (e) => {
    e.preventDefault();

    if (onClick) {
      onClick(e);
    }

    if (getBlocker()) {
      showDialog({ to, state });
    } else {
      navigate(to, { state });
    }
  };

  return (
    <span
      onClick={handleClick}
      className={className}
      style={{ cursor: 'pointer', ...style }}
      {...rest}
    >
      {children}
    </span>
  );
};

export default BlockableLink;
